import type { BranchDetail } from "@/types";

interface BranchHoursTabProps {
  branch: BranchDetail;
}

export default function BranchHoursTab({ branch }: BranchHoursTabProps) {
  const pickupOptions = [
    {
      key: "branch",
      label: "استلام من الفرع",
      description: "يستطيع العميل استلام طلبه مباشرة من الفرع",
      enabled: true,
      icon: "ri-store-3-line",
    },
    {
      key: "car",
      label: "استلام من السيارة",
      description: "خدمة تسليم الطلب للعميل عند السيارة",
      enabled: branch.carPickup,
      icon: "ri-car-line",
    },
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-start gap-3 rounded-box border border-background-200 px-4 py-4">
        <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-time-line"></i>
        </span>
        <div>
          <p className="text-xs text-foreground-500">أوقات العمل</p>
          <p className="mt-0.5 text-sm font-semibold text-foreground-950">
            {branch.hours}
          </p>
        </div>
      </div>

      <div>
        <h3 className="mb-3 text-sm font-bold text-foreground-950">
          سياسة الاستلام
        </h3>
        <div className="space-y-2.5">
          {pickupOptions.map((option) => (
            <div
              key={option.key}
              className="flex items-center justify-between gap-3 rounded-btn border border-background-200 px-4 py-3"
            >
              <span className="inline-flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500">
                  <i className={option.icon}></i>
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">
                    {option.label}
                  </span>
                  <span className="block text-xs text-foreground-500">
                    {option.description}
                  </span>
                </span>
              </span>
              <span
                className={`shrink-0 rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${
                  option.enabled
                    ? "bg-primary-100 text-primary-800"
                    : "bg-background-100 text-foreground-500"
                }`}
              >
                {option.enabled ? "مفعّل" : "غير مفعّل"}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}